<div class="r-modal">
	<div class="r-modal-body" [class]="size">
		<ng-content></ng-content>
	</div>
</div>
<div class="r-modal-background"></div>
